var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-popover",
        {
          ref: "popover",
          attrs: {
            placement: "bottom",
            "boundaries-element": "viewport",
            "popover-class": _vm.isPropertyAccount
              ? "application-filters"
              : "application-filters-just-clients",
            delay: { hide: 100 },
            trigger: "click",
          },
          scopedSlots: _vm._u([
            {
              key: "popover",
              fn: function () {
                return [
                  _c("div", { staticClass: "row no-gutters" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-12 filter-title py-2 column-divider-bottom",
                      },
                      [
                        _c("b", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("application.listing.filterClientsBy")
                              ) +
                              "... "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "row no-gutters" }, [
                        _vm.isPropertyAccount
                          ? _c("div", { staticClass: "col-6" }, [
                              _c("div", { staticClass: "row no-gutters" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-12 py-2 filter-title" },
                                  [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$tc("global.doorr.board")) +
                                          ":"
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row no-gutters" }, [
                                _c(
                                  "fieldset",
                                  {
                                    staticClass: "col-12 d-flex flex-column",
                                    attrs: { id: "board-filters" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "pretty p-default p-round p-smooth mr-0 mb-3",
                                      },
                                      [
                                        _c("input", {
                                          staticClass: "form-check-input",
                                          attrs: {
                                            id: "applications-filter-board--all",
                                            type: "radio",
                                            name: "board-filters",
                                            value: "none",
                                          },
                                          domProps: {
                                            checked:
                                              _vm.selectedTags.board === null,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.handleChange(
                                                "board",
                                                null
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "state p-primary" },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "clickable text-light-gray",
                                                attrs: {
                                                  for: "applications-filter-board--all",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$tc(
                                                      "global.words.all",
                                                      1
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "pretty p-default p-round p-smooth mr-0 mb-3",
                                      },
                                      [
                                        _c("input", {
                                          staticClass: "form-check-input",
                                          attrs: {
                                            id: "applications-filter-board--on-board",
                                            type: "radio",
                                            name: "board-filters",
                                            value: "none",
                                          },
                                          domProps: {
                                            checked:
                                              _vm.selectedTags.board === true,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.handleChange(
                                                "board",
                                                true
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "state p-primary" },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "clickable text-light-gray",
                                                attrs: {
                                                  for: "applications-filter-board--on-board",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "application.listing.onBoard"
                                                      )
                                                    )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "pretty p-default p-round p-smooth mr-0 mb-3",
                                      },
                                      [
                                        _c("input", {
                                          staticClass: "form-check-input",
                                          attrs: {
                                            id: "applications-filter-board--not-on-board",
                                            type: "radio",
                                            name: "board-filters",
                                            value: "none",
                                          },
                                          domProps: {
                                            checked:
                                              _vm.selectedTags.board === false,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.handleChange(
                                                "board",
                                                false
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "state p-primary" },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "clickable text-light-gray",
                                                attrs: {
                                                  for: "applications-filter-board--not-on-board",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "application.listing.notOnBoard"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            class: _vm.isPropertyAccount
                              ? "col-6 pl-3"
                              : "col-12",
                          },
                          [
                            _c("div", { staticClass: "row no-gutters" }, [
                              _c(
                                "div",
                                { staticClass: "col-12 py-2 filter-title" },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("application.listing.newClients")
                                      ) + ":"
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "fieldset",
                                {
                                  staticClass: "col-12 d-flex flex-column",
                                  attrs: { id: "client-filters" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "pretty p-default p-round p-smooth mr-0 mb-3",
                                    },
                                    [
                                      _c("input", {
                                        staticClass: "form-check-input",
                                        attrs: {
                                          id: "applications-filter-clients--all",
                                          type: "radio",
                                          name: "client-filters",
                                          value: "none",
                                        },
                                        domProps: {
                                          checked:
                                            _vm.selectedTags.read === null,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.handleChange(
                                              "client",
                                              null
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "state p-primary" },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "clickable text-light-gray",
                                              attrs: {
                                                for: "applications-filter-clients--all",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$tc("global.words.all", 1)
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "pretty p-default p-round p-smooth mr-0 mb-3",
                                    },
                                    [
                                      _c("input", {
                                        staticClass: "form-check-input",
                                        attrs: {
                                          id: "applications-filter-clients--new",
                                          type: "radio",
                                          name: "client-filters",
                                          value: "none",
                                        },
                                        domProps: {
                                          checked:
                                            _vm.selectedTags.read === false,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.handleChange(
                                              "client",
                                              false
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "state p-primary" },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "clickable text-light-gray",
                                              attrs: {
                                                for: "applications-filter-clients--new",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "application.listing.newClients"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "pretty p-default p-round p-smooth mr-0 mb-3",
                                    },
                                    [
                                      _c("input", {
                                        staticClass: "form-check-input",
                                        attrs: {
                                          id: "applications-filter-clients--old",
                                          type: "radio",
                                          name: "client-filters",
                                          value: "none",
                                        },
                                        domProps: {
                                          checked:
                                            _vm.selectedTags.read === true,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.handleChange(
                                              "client",
                                              true
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "state p-primary" },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "clickable text-light-gray",
                                              attrs: {
                                                for: "applications-filter-clients--old",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "application.listing.oldClients"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 pb-3 filter-title" },
                      [
                        _c("select-filter", {
                          ref: "selectFilter",
                          attrs: {
                            id: "status",
                            name: "status-filter",
                            "status-type": "status",
                            label: _vm.$t("global.words.status") + ":",
                            placeholder: _vm.$t(
                              "application.listing.selectStatusToFilter"
                            ),
                            data: _vm.statuses,
                            value: _vm.statusSelected,
                            "color-degree": 30,
                          },
                          on: { change: _vm.handleSelectChange },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticClass: "tooltip-target" }, [
            _c(
              "div",
              {
                staticClass: "ml-0 mx-lg-3 text-gray capitalize clickable p-2",
              },
              [
                _c("span", { staticClass: "d-flex align-items-center" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$tc("global.words.filter", 1)) +
                      "\n          "
                  ),
                  _c("i", {
                    staticClass: "fa fa-sort-desc ml-1",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }